import React, { useState, useEffect } from 'react';
import { connect } from 'react-redux';
import { NavLink } from 'react-router-dom';
import AfterHeader from '../components/AfterHeader';
import AppDownloadModal from '../components/App/AppDownloadModal';
import { getPromos, cancel } from '../services/promos';
import Placeholder from '../assets/img/placeholders/no-image.png';



const Promos = (props) => {
    const [promos, setPromos] = useState([]);
    const [modal, setModal] = useState(false);

    useEffect(() => {
        document.title = 'Broer - Promociones';
        // GET PROMOS
        loadPromos();

        return cancel;
    }, []);

    const loadPromos = async () => {
        const p = await getPromos();
        setPromos(
            p.promos
                .filter(a => new Date(a.start_date) > new Date() ? false : true)
                .sort((a, b) => a.points > b.points ? 1 : -1)
        );
    };

    return (
        <main>
            <AfterHeader text="Catálogo" small={"Canjeá tus Estrellas"} />
            <div className="row mt-5 px-md-5 px-3">
                {
                    promos.map(promo => (
                        <div className="col-lg-4 col-xl-3 col-sm-6 col-xs-12" key={promo._id}>
                            <NavLink to={`/promo/${promo._id}`} className="card promo-card mb-4">
                                {
                                    promo?.images[0]?.url ?
                                    <img className="card-img-top" src={promo.images[0].url} alt={promos.description_title} />
                                    :
                                    <img className="card-img-top" src={Placeholder} alt={promos.description_title} />
                                }
                            </NavLink>
                        </div>
                    ))
                }
            </div>

            <AppDownloadModal show={modal} setShow={setModal} />
        </main>
    )
};

const mapStateToProps = state => ({
    assets: state.assets,
});

export default connect(mapStateToProps)(Promos);
